export const AUTH_FLOW_STATE = {
  completedInThisSession: false,
};
